import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { temporarilySetLevelIncreaseStatus } from './kycActions';
import { closeKYCSidePane } from './sidePaneActions';
import { showSnack } from './snackbarActions';
export var PROCESSING_SET_USER_CONFIG = 'PROCESSING_SET_USER_CONFIG';
export var FINISHED_SET_USER_CONFIG = 'FINISHED_SET_USER_CONFIG';
export var processingSetUserConfig = {
  type: PROCESSING_SET_USER_CONFIG
};
export var finishedSetUserConfig = {
  type: FINISHED_SET_USER_CONFIG
};
export var setUserConfigForManualKYC = function setUserConfigForManualKYC(UserId, UserName, underReviewLevel, Config) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var userConfig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(processingSetUserConfig);
              _context.next = 3;
              return dispatch(callAPI('SetUserConfig', {
                UserId: UserId,
                UserName: UserName,
                Config: Config
              }));
            case 3:
              userConfig = _context.sent;
              if (userConfig.result !== false) {
                dispatch(temporarilySetLevelIncreaseStatus({
                  underReviewLevel: underReviewLevel
                }));
                dispatch(showSnack({
                  id: 'setUserConfigForKYCSuccess',
                  // context.t('Your information has been submitted and is under review. Your verification status will be updated 24-48 hours from the time of submission.')
                  text: 'Your information has been submitted and is under review. Your verification status will be updated 24-48 hours from the time of submission.',
                  type: 'success'
                }));
                dispatch(closeKYCSidePane());
              } else {
                dispatch(showSnack({
                  id: 'setUserConfigForKYCError',
                  // context.t('There was an error in submitting your information. Please try again.')
                  text: 'There was an error in submitting your information. Please try again.',
                  type: 'warning'
                }));
              }
              dispatch(finishedSetUserConfig);
            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};